export default {
	'Login' : {
		url:"users/login",
    },
    'SignUp' : {
		url:"users/register",
	}
}